import styled from 'styled-components';
import { Text16Light } from '../utils/Text/Text.styles';
import { Button } from '../utils/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 76rem;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 2.4rem 0;

  @media only screen and (max-width: 760px) {
    padding: 1.6rem 1.2rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0.8rem 0 3.8rem 0;

  @media only screen and (max-width: 700px) {
    margin-bottom: 1.6rem;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  gap: 1.6rem;

  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

export const DescriptionText = styled(Text16Light)`
  line-height: 2.9rem;
  letter-spacing: -0.408px;
  text-align: center;

  @media only screen and (max-width: 500px) {
    text-align: start;
  }
`;

export const Card = styled.div`
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 1.6rem 1.6rem 1.2rem 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 23rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding-left: 1.6rem;
`;

export const StyledButton = styled(Button)`
  height: 3.6rem;
  font-weight: 400;
  border-radius: 12px;
`;
